import * as React from "react"
import {Box, Paper} from "@mui/material";
import {useSelector} from "react-redux";
// import StatsTable from "../components/StatsTable";
import Typography from "@mui/material/Typography";
import {useEffect, useState} from "react";
import StatsChart from "../components/StatsChart";
import StatsTablePC from "../components/dark_version/StatsTablePC";
import StatsTable from "../components/StatsTable";

export interface IDashboardParams {
    donor: string
    region: string
    sector: string
    sro: string
}

const Dashboard = () => {
    const contentDivHeight = useSelector((state: any) => state.base.contentDivHeight);
    const headerHeight = 30
    const rowPadding = 10
    // const paperHeight = contentDivHeight - 2 * rowPadding - headerHeight - 5;
    const [paperHeight, setPaperHeight] = useState(0)
    React.useEffect(() => {
        const height = contentDivHeight - 2 * rowPadding - headerHeight - 5;
        setPaperHeight(height)
    }, [contentDivHeight])
    const [headerContent, setHeaderContent] = useState("NATIONAL PORTFOLIO")
    //@ts-ignore
    const params: IDashboardParams = useSelector((state: any) => state.dashboard);

    useEffect(() => {
        setHeaderContent(
            `${params.region.toLowerCase() === "all" ? "National" : params.region}
            ${params.sro.toLowerCase() === "all" ? "" :
                params.sector.toLowerCase() === "all" ? " and " + params.sro : " and " + params.sector} 
                ${params.donor.toLowerCase() === "all" ? "" : " and " + params.donor}
                Portfolio`)

    }, [params])

    return (
        <React.Fragment>
            <div id={"div-header"} className={"row"} style={{height: headerHeight}}>
                <div className={"col-lg-12"}
                     style={{display: 'flex', background: '#696969', alignItems: 'center'}}>
                    <Box
                        sx={{display: 'flex', flexDirection: 'row', margin: "auto"}}>
                        <Typography sx={{color: 'white'}}
                                    align={"center"}
                                    variant="h5"
                                    component="div"
                        >
                            {/*{headerContent} (USD in Million)*/}
                            {headerContent} (USD in Million)
                        </Typography>
                    </Box>
                </div>
            </div>
            <div className="container-fluid" style={{backgroundColor: "transparent"}}>
                <div className="row" style={{padding: rowPadding}}>
                    <div className="col-md-12 col-lg-6">
                        <Paper elevation={6}
                               sx={{
                                   borderRadius: "16px",
                                   boxShadow: "0px 4px 24px #00000012",
                                   p: 1, height: (paperHeight), overflowY: "auto",
                                   overflowX: "hidden", boxSizing: "border-box"
                               }}>
                            {/*<StatsTable/>*/}
                            <StatsTablePC height={paperHeight}/>
                        </Paper>
                    </div>
                    <div className="col-md-12 col-lg-6">
                        <Paper elevation={6}
                               style={{
                                   borderRadius: "16px",
                                   boxShadow: "0px 4px 24px #00000012",
                                   padding: "0px", height: (paperHeight), overflowY: "auto",
                                   overflowX: "hidden"
                               }}>
                            <StatsChart/>
                        </Paper>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Dashboard
